export default "__VITE_ASSET__OmL0is1d__"